
import { useParams, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Component to handle old /listing/:id routes and redirect to /product/:id
const ListingDetail = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <>
      <Helmet>
        <title>Ridrejtim | TreguIm</title>
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href={`/product/${id}`} />
        <meta http-equiv="refresh" content={`0;url=/product/${id}`} />
      </Helmet>
      
      <Navigate to={`/product/${id}`} replace />
    </>
  );
};

export default ListingDetail;
